import {
  IWizardStudentState,
  TWizardStepComponentStatic
} from "../../interfaces";
import React, { forwardRef } from "react";

import FinishImage from "assets/images/wizard/WizardStepFinish.webp";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import {
  DebugInfo,
  Footer,
  Header,
  HeaderButtons,
  Progress,
  Root,
  StepContainer,
  StepContainerDefault,
  StepDescription,
  StepTitle
} from "../styles";
import { Button } from "antd";
import { theme } from "../../../../styles/theme";
import { STUDENT_ROOMS_ROUTE } from "../../../../utils/constants";
import { useHospiNavigate } from "../../../../utils/common";

const Image = styled.img`
  width: 100%;
  margin-bottom: 40px;
`;

export const WizardStepStartSearchPage: TWizardStepComponentStatic<IWizardStudentState> =
  forwardRef(() => {
    const { t } = useTranslation("student");
    const navigate = useHospiNavigate();

    return (
      <Root>
        <Header>
          <DebugInfo>Step Final</DebugInfo>
          <HeaderButtons>
            <Button
              size="large"
              style={{
                visibility: "hidden"
              }}
            >
              Any text
            </Button>
          </HeaderButtons>
        </Header>
        <Progress
          percent={100}
          showInfo={false}
          strokeColor={theme.colors.primary}
        />
        <StepContainer>
          <StepContainerDefault>
            <div>
              <Image src={FinishImage}></Image>
              <StepTitle
                dangerouslySetInnerHTML={{
                  __html: t("wizard.steps.StartSearch.mainTitle").replaceAll(
                    "\n",
                    "<br/>"
                  )
                }}
              />
              <StepDescription
                dangerouslySetInnerHTML={{
                  __html: t(
                    "wizard.steps.StartSearch.mainDescription"
                  ).replaceAll("\n", "<br/>")
                }}
              />
            </div>
          </StepContainerDefault>
        </StepContainer>
        <Footer>
          <div
            style={{
              flexGrow: "1"
            }}
          ></div>
          <Button
            onClick={() => {
              navigate(STUDENT_ROOMS_ROUTE);
            }}
            type="primary"
            size="large"
          >
            {t("wizard.buttonStartSearch")}
          </Button>
        </Footer>
      </Root>
    );
  });
